module.exports = __webpack_public_path__ + "img/KY.30cfba78.svg";